import { render, staticRenderFns } from "./task-approve-detail.vue?vue&type=template&id=69659e4f&scoped=true&"
import script from "./task-approve-detail.vue?vue&type=script&lang=js&"
export * from "./task-approve-detail.vue?vue&type=script&lang=js&"
import style0 from "./task-approve-detail.vue?vue&type=style&index=0&id=69659e4f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69659e4f",
  null
  
)

export default component.exports